<template>
    <div class="pp-apartment-models-component pp-type-component">
        <div class="section-loading-screen" v-if="showLoading">
            <div class="section-loading-bubbles">
                <span class="d1"></span>
                <span class="d2"></span>
                <span class="d3"></span>
                <span class="d4"></span>
            </div>
        </div>

        <div class="pdetail-elements-group">
          <ul class="checkboxes-list">
            <li class="text-placeholder-radio" v-for="(value, key) in roomsCount" :key="key">
                <input type="checkbox"
                        :id="`apartmentRoomId${value.id}`"
                        class="text-checkbox-input"
                        :value="value.id"
                        v-model="roomsCountFilter"
                        @change="changeRoomsCountFilter()"
                />
                <label :for="`apartmentRoomId${value.id}`" class="radio-input-placeholder">
                    <span> {{ value.name }} </span>
                </label>
                <span class="text-checkbox-counter" v-if="hasAccessToProjectItems"> {{getNumberOfItemsPerRoomCount(value.id)}} </span>
            </li>
          </ul>
        </div>
        <div class="pdetail-elements-group pdetail-filters-group"
             v-if="hasSurfaceFilter || hasPriceFilter">
            <h3 class="pp-tab-heading">
                Filtre active:
                <a class="reset-filters" href="javascript:void(0)"
                   @click="resetSurfaceAndPriceFilters()">Reseteaza filtre</a>
            </h3>
            <ul class="results-tag-list">
                <li v-if="hasPriceFilter">
                    <span class="results-tag">
                        <span> Pret: {{ getPriceFilterLabel }} </span>
                        <i
                            class="fad fa-times-circle"
                            @click="resetPriceFilter()"
                        ></i>
                    </span>
                </li>
                <li v-if="hasSurfaceFilter">
                    <span class="results-tag">
                        <span> Suprafata: {{ getSurfaceFilterLabel }} </span>
                        <i
                            class="fad fa-times-circle"
                            @click="resetSurfaceFilter()"
                        ></i>
                    </span>
                </li>
            </ul>
        </div>
        <div class="pp-models-list-container">
            <h2 class="pp-tab-heading combo">
              <span class="floating-counter d-none d-lg-block">
                <span>Tipuri </span><span>{{ displayModels.length }}</span>/<span>{{ models.length }}</span>
              </span>
            </h2>
            <div class="pp-models-list">
                <div :class="{
                        'pp-model-item': true,
                        'flat': true,
                        'dimmed': showFirstApartmentModels && key === showFirstApartmentModelsCount,
                        'hidden': showFirstApartmentModels && key > showFirstApartmentModelsCount
                     }"
                     :id="getModelHashTagWithoutType(model)"
                     :data-id="model.id"
                     v-for="(model, key) in displayModels" :key="key">
                    <div class="sold-tag" v-if="isModelSold(model)">
                        Vandut
                    </div>
                    <div class="available-tag"
                         v-else-if="!hasAccessToProjectItems && getNrDisponibleModelItems(model)">
                        Disponibil
                    </div>
                    <div class="unavailable-tag"
                         v-else-if="!hasAccessToProjectItems && !getNrDisponibleModelItems(model)">
                        Indisponibil
                    </div>
                    <div class="element-dropdown">
                        <div class="element-floating-menu" @click="setActiveDropdown(key)">
                            <i class="fad fa-ellipsis-v-alt"></i>
                        </div>
                        <ul
                          class="actions-dropdown"
                          :class="{'actions_dropdown_active': activeModelIndex === key}"
                          ref="dropdown"
                        >
                            <li>
                                <i class="fad fa-phone-rotary"></i>
                                <a href="javascript:void(0)" class="general-link" @click="openPublicContactModalProject(model.project,model)"> Call </a>
                            </li>
                            <li>
                                <i class="fad fa-copy"></i>
                                <a href="javascript:void(0)" class="general-link" @click="copyLink(model,'model')"> Copy link </a>
                            </li>
                            <li>
                                <i class="fab fa-whatsapp"></i>
                                <a :href="`https://api.whatsapp.com/send?text=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Whatsapp </a>
                            </li>
                            <li>
                                <i class="fab fa-facebook-square"></i>
                                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${getFullModelUrl(model)}`" class="general-link" target="_blank"> Share Facebook </a>
                            </li>
                        </ul>
                    </div>
                    <div v-if="checkFavorite(model)" class="floating-favourite-element floating-active-favrourite">
                        <i class="fas fa-heart" @click="deleteFavoriteModel(model.id)"></i>
                    </div>
                    <div v-else class="floating-favourite-element">
                        <i class="fas fa-heart" @click="openAddFavoriteModelModal(model.id, model.project_id)"></i>
                    </div>
                    <div class="pp-model-item-content pp-length-flex">
                        <div class="pp-model-picture pp-length-picture no-border pseudo-link" @click="openModelDetailModal(projectId, model.id, 'apartments')" :style="{ backgroundImage: 'url(' + model.first_listing_image_url + ')' }">
                        </div>
                        <div class="pp-model-info pp-length-info">
                            <div class="pp-model-info-strip">
                                <h2 class="pp-model-item-heading">
                                    <a href="javascript:void(0)" @click="openModelDetailModal(projectId, model.id, 'apartments')"> {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }} </a>
                                </h2>
                            </div>
                            <div class="pp-model-info-strip">
                                <h2> Pret incepand de la:</h2>
                                <p v-if="isModelSold(model)">
                                    --
                                </p>
                                <p v-else>
                                    {{ formatPrice(model.min_price) }} ({{model.price_with_vat ? 'TVA inclus' : '+TVA'}})
                                </p>
                            </div>
                            <div class="pp-model-info-strip" v-if="model.min_credit_price">
                                <h2> Pret cu credit de la:</h2>
                                <p v-if="isModelSold(model)">
                                    --
                                </p>
                                <p v-else>
                                    {{ formatPrice(model.min_credit_price) }} ({{model.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})
                                </p>
                            </div>
                            <div class="pp-model-info-strip">
                                <ul>
                                    <li>
                                        <span>Suprafata totala: {{ model.min_surface }} m² </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="pp-model-info-strip">
                                <p
                                    v-if="model.total_items > 0"
                                    @click="openModelDetailModal(projectId, model.id, 'apartments', true, getBuildingsFilterFirst(model.buildings))"
                                    class="pp-avb-item"
                                >
                                    <span v-if="hasAccessToProjectItems">
                                        Disponibile: {{ getNrDisponibleModelItems(model) }}
                                    </span>
                                    <span v-else>
                                        Vezi detalii
                                    </span>
                                </p>
                                <p v-else>
                                    <span
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Dezvoltatorul nu a afisat disponibilitatile"
                                >
                                        <i class="fad fa-info-circle"></i> Apartamente
                                    </span>
                                </p>
                            </div>
                            <div class="pp-model-info-strip pp-last-offers" v-if="1 <= getNrDisponibleModelItems(model) && getNrDisponibleModelItems(model) <= 3">
                                <p>
                                    <span v-if="getNrDisponibleModelItems(model) > 1">
                                        Ultimele {{ getNrDisponibleModelItems(model) }} oferte disponibile
                                    </span>
                                    <span v-else>
                                        Ultima oferta disponibila
                                    </span>
                                </p>
                            </div>
                            <div class="pp-model-info-strip pp-recent-sales"
                                 v-if="model.items_sold_today || model.items_sold_yesterday || model.items_sold_recently">
                                <p>
                                    <span v-if="model.items_sold_today">
                                        {{ model.items_sold_today }}
                                        {{ model.items_sold_today === 1 ? 'ofertă vândută azi' : 'oferte vândute azi' }}
                                    </span>
                                    <span v-else-if="model.items_sold_yesterday">
                                        {{ model.items_sold_yesterday }}
                                        {{ model.items_sold_yesterday === 1 ? 'ofertă vândută ieri' : 'oferte vândute ieri' }}
                                    </span>
                                    <span v-else>
                                        {{ model.items_sold_recently }}
                                        {{ model.items_sold_recently === 1 ? 'ofertă vândută recent' : 'oferte vândute recent' }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="showFirstApartmentModels && displayModels.length > showFirstApartmentModelsCount">
                <div class="col-xl-12 col-lg-12 col-12">
                    <div class="view-more-item view-more-item--model-list">
                        <span class="view-more-btn view-more-btn--model-list" @click="showFirstApartmentModels = false">
                            Vezi mai mult
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PublicProjectApartmentModels",
    props: ['projectId','roomsCountList','defFavorites','hasAccessToProjectItems'],
    components: {
      // editor
    },
    data() {
      return {
        activeModelIndex: undefined,
        showLoading: false,
        roomsCount: [],
        buildings: [],
        favorites: [],
        roomsCountFilter: [],
        models: [],
        showFirstApartmentModels: true,
        showFirstApartmentModelsCount: 10,
        priceFilter: {
            minPrice: null,
            maxPrice: null,
        },
        surfaceFilter: {
            minSurface: null,
            maxSurface: null,
        },
      }
    },
    async mounted() {
      let vm = this
      sessionStorage.setItem('project' + vm.projectId + 'ApartmentModelsLoaded', false);
      this.showLoading = true;
      this.$eventBus.$on('SAVED_FAVORITES', function (payLoad) {
        let fav = payLoad.fav;
        vm.favorites = vm.favorites || [];
        vm.favorites = vm.favorites.concat(fav);
      });
      await this.getBuildings()
      await this.getModels()
      if (this.defFavorites) {
        this.favorites = this.defFavorites
      } else {
          this.favorites = window.getLocalFavorites();
      }

      let params = window.getAllUrlParams(window.location.href);
      if (Object.keys(params).length === 0) {
          params = window.projectUrlParamsFromLocalStorage || {};
      }

      if(params.camere) {
        if(Array.isArray(params.camere)) {
          params.camere = params.camere.map(function (item) {
            return parseInt(item, 10);
          });
          params.camere.forEach(roomCount => {
            this.roomsCountFilter.push(roomCount)
          });
        } else {
          let roomCount = parseInt(params.camere, 10);
          this.roomsCountFilter.push(roomCount)
        }
      }

      if (params.suprafata_min || params.suprafata_max) {
          this.surfaceFilter.minSurface = params.suprafata_min && !isNaN(parseFloat(params.suprafata_min))
              ? parseFloat(params.suprafata_min)
              : null;
          this.surfaceFilter.maxSurface = params.suprafata_max && !isNaN(parseFloat(params.suprafata_max))
              ? parseFloat(params.suprafata_max)
              : null;

      }

      if (params.pret_min || params.pret_max) {
          this.priceFilter.minPrice = params.pret_min && !isNaN(parseFloat(params.pret_min))
              ? parseFloat(params.pret_min)
              : null;

          this.priceFilter.maxPrice = params.pret_max && !isNaN(parseFloat(params.pret_max))
              ? parseFloat(params.pret_max)
              : null;
      }

      this.$eventBus.$on('DELETED_FAVORITES_MODAL', function (payLoad) {
        if(vm.favorites.length > 0)
        {
          vm.favorites.forEach((fav, key) => {
            if(fav.favoritable_id == payLoad.favId && fav.favoritable_type === 'App\\ProjectModel')
            {
              vm.favorites.splice(key, 1);
              return;
            }
          });
        }
      });
    },
    computed: {
      displayModels(){
        let output = []
        for(let i in this.models){
          if(this.passFilter(this.models[i])){
            output.push(this.models[i])
          }
        }
        return output
      },
        hasSurfaceFilter(){
          return this.surfaceFilter.minSurface || this.surfaceFilter.maxSurface
        },
        hasPriceFilter(){
          return this.priceFilter.minPrice || this.priceFilter.maxPrice
        },
        getSurfaceFilterLabel(){
            if(this.surfaceFilter.minSurface && this.surfaceFilter.maxSurface) {
                return this.surfaceFilter.minSurface + ' - ' + this.surfaceFilter.maxSurface + ' m²';
            } else if(this.surfaceFilter.minSurface) {
                return 'min ' + this.surfaceFilter.minSurface + ' m²';
            } else if(this.surfaceFilter.maxSurface) {
                return 'max ' + this.surfaceFilter.maxSurface + ' m²';
            }

            return '';
        },
        getPriceFilterLabel(){
            if(this.priceFilter.minPrice && this.priceFilter.maxPrice) {
                return this.priceFilter.minPrice + ' - ' + this.priceFilter.maxPrice + ' €';
            } else if(this.priceFilter.minPrice) {
                return 'min ' + this.priceFilter.minPrice + ' €';
            } else if(this.priceFilter.maxPrice) {
                return 'max ' + this.priceFilter.maxPrice + ' €';
            }

            return '';
        }
    },
    watch: {
      displayModels() {
        this.setDisplayTypes();
      }
    },
    methods: {
      setDisplayTypes() {
        const el = document.querySelector('#apartments-types > span');
        el.innerHTML = `Tipuri ${this.displayModels.length}/${this.models.length}`;
      },
      async getBuildings() {
        let vm = this
        await window.axios.get(`/ajax/get-buildings-by-model-type/${this.projectId}/apartment`)
          .then(function (resp) {
            vm.buildings = resp.data.data
          })
          .catch(function () {
            // window.showError(err)
          });
      },
      async getModels() {
        let vm = this
        vm.showLoading = true
        await window.axios.get(`/ajax/get-models/${this.projectId}/apartment`)
          .then(function (resp) {
            vm.models = resp.data.data
            // vm.models.sort(function(a, b) { return a.rooms_count.sort_order - b.rooms_count.sort_order})
            for(let i in vm.models) {
              let roomCountObj = vm.roomsCountList.find(r => r.id === vm.models[i].rooms_count_id)
              if(!vm.roomsCount.includes(roomCountObj)){
                vm.roomsCount.push(roomCountObj)
              }
              vm.roomsCount.sort(function(a, b) { return a.sort_order - b.sort_order})
            }
            vm.showLoading = false
            sessionStorage.setItem('project' + vm.projectId + 'ApartmentModelsLoaded', true);
          })
          .catch(function () {
            vm.showLoading = false
          });
      },
      setActiveDropdown(key) {
        this.activeModelIndex = key
        const dropdown = this.$refs.dropdown[key]
        if (!dropdown.classList.contains('actions_dropdown_active')) {
          dropdown.classList.add('actions_dropdown_active')
        } else {
          dropdown.classList.remove('actions_dropdown_active')
        }
      },
      changeRoomsCountFilter() {
        let vm = this
        this.showLoading = true
        this.showFirstApartmentModels = true;
        setTimeout(function(){ vm.showLoading = false }, 500);
      },
      passFilter(model) {
        if(this.roomsCountFilter.length > 0 && !this.roomsCountFilter.includes(model.rooms_count_id)){
          return false
        }

          if (this.surfaceFilter.minSurface && parseFloat(model.min_surface) < this.surfaceFilter.minSurface) {
              return false
          }
          if (this.surfaceFilter.maxSurface && parseFloat(model.min_surface) > this.surfaceFilter.maxSurface) {
              return false
          }
          if (
              this.priceFilter.minPrice && (
                  this.isModelSold(model) ||
                  parseFloat(model.min_price) < this.priceFilter.minPrice
              )
          ) {
              return false
          }
          if (
              this.priceFilter.maxPrice && (
                  this.isModelSold(model) ||
                  parseFloat(model.min_price) > this.priceFilter.maxPrice
              )
          ) {
              return false
          }

        return true
      },
      checkFavorite(model) {
        if (this.favorites && this.favorites.length > 0) {
          let exists = this.favorites.filter(favorite => favorite.favoritable_type == 'App\\ProjectModel' && favorite.favoritable_id === model.id)
          return exists.length > 0
        } else {
          return false;
        }
      },
      deleteFavoriteModel(id) {
        let vm = this;
        if(vm.defFavorites) { // logged in
            window.axios.delete(`/ajax/favorites/${id}/model`)
                .then(function () {
                    vm.favorites.forEach(function (fav, key) {
                        if (fav.favoritable_type === 'App\\ProjectModel' && fav.favoritable_id === id) {
                            vm.favorites.splice(key, 1);
                            vm.$eventBus.$emit('DELETED_FAVORITES_LIST', {
                              favId: id
                            });
                        }
                    });
                    window.Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        html: 'Modelul a fost sters din lista de favorite.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                })
                .catch(function (err) {
                    window.showError(err)
                });
        } else {
            vm.favorites = vm.favorites.filter(
                fav => !(
                        fav.favoritable_type === "App\\ProjectModel" &&
                        fav.favoritable_id === id
                    )
            );
            window.saveLocalFavorites(vm.favorites);

            window.Swal.fire({
                position: 'top-end',
                icon: 'success',
                html: 'Modelul a fost sters din lista de favorite.',
                showConfirmButton: false,
                timer: 1500
            });
        }
      },
      getNumberOfItemsPerRoomCount(roomCountId) {
        let models = this.models.filter(m => (m.rooms_count_id === roomCountId))

        let sum = 0;
        let nr = 0;
        models.forEach(function(model){
            nr = model.items.filter(item => item.status === 'available');
            sum += parseInt(nr.length)
        })
        return sum;
      },
      getNrDisponibleModelItems(model) {
        let sum = 0;
        let nr = 0;
          nr = model.items.filter(item => item.status === 'available');
          sum += parseInt(nr.length)
        return sum;
      },
      getBuildingsFilterFirst(modelBuildings) {
        const buildings = modelBuildings.sort((a, b) => a.id - b.id);

      return buildings[0];
      },
        resetPriceFilter() {
            let vm = this
            this.showLoading = true
          this.priceFilter.minPrice = null;
          this.priceFilter.maxPrice = null;
            setTimeout(function(){ vm.showLoading = false }, 500);
        },
        resetSurfaceFilter() {
            let vm = this
            this.showLoading = true
          this.surfaceFilter.minSurface = null;
          this.surfaceFilter.maxSurface = null;
            setTimeout(function(){ vm.showLoading = false }, 500);
        },
        resetSurfaceAndPriceFilters() {
            let vm = this
            this.showLoading = true
            this.surfaceFilter.minSurface = null;
            this.surfaceFilter.maxSurface = null;
            this.priceFilter.minPrice = null;
            this.priceFilter.maxPrice = null;
            setTimeout(function(){ vm.showLoading = false }, 500);
        },
        isModelSold(model) {
          return model.total_items > 0 && model.total_items === model.items_sold;
        }
    }
  }
</script>
